import { render, staticRenderFns } from "./channelAction.vue?vue&type=template&id=79052bf4&"
import script from "./channelAction.vue?vue&type=script&lang=js&"
export * from "./channelAction.vue?vue&type=script&lang=js&"
import style0 from "./channelAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports